import React from "react";
import { Button, Modal } from "@mui/material";
import styles from "./PublishModal.module.scss";

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onCheck: () => void;
  isPublish: boolean;
};

export const PublishModal = ({
  isOpen,
  setIsOpen,
  onCheck,
  isPublish,
}: Props) => {
  return (
    <Modal
      aria-labelledby="modal-delete"
      aria-describedby="Removal from the system. Confirm the deletion"
      open={isOpen}
      onClose={() => setIsOpen(false)}
    >
      <div className={styles.modalContainer}>
        <h3 className={styles.modalTitle}>
          {isPublish ? "Remove option?" : "Publish option?"}
        </h3>
        <p className={styles.modalSupportText}>
          {isPublish
            ? "The option will be removed from the application"
            : "The option will appear in the application"}
        </p>
        <div className={styles.modalContent}>
          <div className={styles.btns}>
            <Button
              sx={{
                textTransform: "capitalize",
                height: "44px",
                width: "130px",
                backgroundColor: isPublish ? "#ff0000" : "#008000",
                border: "none",
                borderRadius: "12px",
              }}
              variant="contained"
              onClick={onCheck}
            >
              {isPublish ? "Remove" : "Publish"}
            </Button>

            <Button
              variant="outlined"
              sx={{
                textTransform: "capitalize",
                height: "44px",
                width: "130px",
                border: "1px solid #5570F1",
                color: "#5570F1",
                borderRadius: "12px",
              }}
              onClick={() => setIsOpen(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

